import { Box } from '@/components/Box/Box';
import SuccessSecondaryIcon from '@/images/SuccessSecondaryIcon.svg?react';
import { AcceptedAgreementDetailsWrapper, Details, DetailsValue, Divider } from './styles';
import { Typography } from '@/components/Typography/Typography';
import capitalize from 'lodash/capitalize';
import { COLORS } from '@/styles/colors';
import { InternalOrganizationMasterServiceAgreementDetailsResponseType } from '@/api/v1/organization/internal/getInternalOrganizationMasterServiceAgreementDetailsApi';
import { formatDateTimeUTC } from '@/helpers/dateHelpers/dateHelpers';

type AcceptedAgreementDetailsType = {
  details: InternalOrganizationMasterServiceAgreementDetailsResponseType;
  modifiedDate: string;
};

const formatFullName = (firstName: string, lastName: string, middleName?: string) => {
  const middleInitial = middleName?.trim() ? ` ${middleName.trim().charAt(0).toUpperCase()}.` : '';

  return `${capitalize(firstName.trim())}${middleInitial} ${capitalize(lastName.trim())}`;
};

export const AcceptedAgreementDetails = ({ details, modifiedDate }: AcceptedAgreementDetailsType) => {
  const { first_name, middle_name, last_name, confirm_user_email, date_created } = details;

  const fullName = formatFullName(first_name, last_name, middle_name);
  const confirmedDate = formatDateTimeUTC(date_created);

  return (
    <Box
      display='flex'
      flexDirection={'row'}
      rowGap='12px'
      alignItems='center'
      columnGap='24px'
      width='100%'
      margin='4px 0 8px'
      mobile={{ flexDirection: 'column' }}
    >
      <Box>
        <SuccessSecondaryIcon />
      </Box>

      <AcceptedAgreementDetailsWrapper>
        <Details>
          <Box display='flex' alignItems='center' justifyContent='space-between'>
            <Typography color={COLORS.black} variant='bodySmall'>
              MSA Version:
            </Typography>
            <Typography color={COLORS.black} variant='bodySmall' fontWeight='medium'>
              Last modified: {modifiedDate}
            </Typography>
          </Box>
          <Box display='flex' alignItems='center' justifyContent='space-between'>
            <Typography color={COLORS.black} variant='bodySmall'>
              Signed on:
            </Typography>
            <Typography color={COLORS.black} variant='bodySmall' fontWeight='medium'>
              {confirmedDate} UTC
            </Typography>
          </Box>
        </Details>
        <Divider />
        <Details>
          <Box display='flex' alignItems='center' justifyContent='space-between' columnGap='12px'>
            <Typography color={COLORS.black} variant='bodySmall' flexShrink={0}>
              Signed By:
            </Typography>
            <DetailsValue color={COLORS.black} variant='bodySmall' fontWeight='medium' title={fullName}>
              {fullName}
            </DetailsValue>
          </Box>
          <Box display='flex' alignItems='center' justifyContent='space-between' columnGap='12px'>
            <Typography color={COLORS.black} variant='bodySmall' flexShrink={0}>
              Signer`s Email:
            </Typography>
            <DetailsValue color={COLORS.black} variant='bodySmall' fontWeight='medium' title={confirm_user_email}>
              {confirm_user_email}
            </DetailsValue>
          </Box>
        </Details>
      </AcceptedAgreementDetailsWrapper>
    </Box>
  );
};
